import { v4 } from 'uuid';

export const get = async <T = unknown>(endpoint: string) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('x-sessionId', sessionStorage.getItem('x-sessionId') ?? '');
  headers.append('x-requestId', v4());
  const response = await fetch(window.location.origin + endpoint, {
    headers
  });

  if (response?.status >= 400) {
    throw new Error(response.statusText);
  }
  return (await response.json()) as T;
};
